export default __webpack_public_path__ + "static/media/img-slider-lh-job-sale-1.1a1f0a8e.png";